<template>
  <div>
    <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">{{ alert_success_message
    }}</b-alert>

    <b-alert variant="danger" :show="showAlert_error" @dismissed="showAlert_error = false">{{ alert_error_message
    }}</b-alert>

    <b-container fluid>
      <h3 class="mt-3 mb-3">Trackings Status</h3>

      <b-card class="mb-1" v-if="
        $store.state.user_obj &&
        $store.state.user_obj.user_name != 'lna_client'
      ">
        <div class="search_bar mb-3" v-if="
          checkPermission(
            $store.state.user_obj,
            'Delivery Management',
            'Delivery Status',
            'Upload Orders',
            true
          )
        ">
          <!-- <b-row v-if="this.$store.state.user_obj.account_type == 'admin'"> -->
          <b-row>
            <b-col cols="4" class="pr-1">
              <b-form-file v-model="upload_file" size="sm" placeholder="Choose a file..."></b-form-file>
            </b-col>

            <b-col class="text-left p-0">
              <b-button class="btn-action" size="sm" variant="info" @click="onUploadFile">Upload</b-button>
            </b-col>
          </b-row>
        </div>

        <div class="search_bar mb-3" v-if="
          checkPermission(
            $store.state.user_obj,
            'Delivery Management',
            'Delivery Status',
            'Import Tracking # & Courier',
            true
          )
        ">
          <!-- <b-row v-if="this.$store.state.user_obj.account_type == 'admin'"> -->
          <b-row>
            <b-col cols="4" class="pr-1">
              <b-form-file v-model="upload_file_tracking" size="sm" placeholder="Choose a file..."></b-form-file>
            </b-col>

            <b-col class="text-left p-0">
              <b-button class="btn-action" size="sm" variant="info" @click="onImportTrackingNum">Import Tracking# &
                Courier</b-button>
            </b-col>
          </b-row>
        </div>

        <div class="search_bar mb-3" v-if="
          checkPermission(
            $store.state.user_obj,
            'Delivery Management',
            'Delivery Status',
            'Import Status',
            true
          )
        ">
          <b-row>
            <b-col cols="4" class="pr-1">
              <b-form-file v-model="upload_file_tracking_status" size="sm" placeholder="Choose a file..."></b-form-file>
            </b-col>

            <b-col class="text-left p-0">
              <b-button class="btn-action" size="sm" variant="info" @click="onImportStatus">Import Status</b-button>
            </b-col>
          </b-row>
        </div>

        <div class="search_bar" v-if="
          checkPermission(
            $store.state.user_obj,
            'Delivery Management',
            'Delivery Status',
            'Import Packing Sector Priority',
            true
          )
        ">
          <!-- <b-row v-if="this.$store.state.user_obj.account_type == 'admin'"> -->
          <b-row>
            <b-col cols="4" class="pr-1">
              <b-form-file v-model="upload_file_packing_sector_priority" size="sm"
                placeholder="Choose a file..."></b-form-file>
            </b-col>

            <b-col class="text-left p-0">
              <b-button class="btn-action" size="sm" variant="info" @click="onImportPackingSectorPriority">Import
                Packing Sector Priority</b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-card class="mb-2">
        <div class="search_bar">
          <b-row>
            <b-col cols="2" class="pr-1">
              <b-form-select size="sm" v-model="search_criteria.status_selected" :options="status_options" />
            </b-col>

            <b-col cols="3" class="pl-0 pr-1">
              <b-form-input id="input-small" size="sm" type="text" placeholder="Order#/Tracking#/Attention/Phone"
                v-model="search_criteria.keyword"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="2" class="pr-1">
              <b-form-input id="input-small" size="sm" type="text" value="Upload Date" :disabled="true"></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.start_at"></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.end_at"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="2" class="pr-1">
              <b-form-select size="sm" v-model="search_criteria.scheduled_delivery_date"
                :options="scheduled_delivery_date_options" />
            </b-col>

            <b-col cols="2" class="pl-0 pr-1" v-if="search_criteria.scheduled_delivery_date == 'scheduled_date_yes'">
              <b-form-input id="input-small" size="sm" type="date"
                v-model="search_criteria.scheduled_delivery_date_start_at"></b-form-input>
            </b-col>

            <b-col cols="2" class="pl-0 pr-1" v-if="search_criteria.scheduled_delivery_date == 'scheduled_date_yes'">
              <b-form-input id="input-small" size="sm" type="date"
                v-model="search_criteria.scheduled_delivery_date_end_at"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="2" class="pr-1">
              <b-form-select size="sm" v-model="search_criteria.waybill_status_selected"
                :options="waybill_status_options" />
            </b-col>

            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.pdf_status_selected" :options="PDF_status_options" />
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col cols="2" class="pr-1">
              <b-form-select size="sm" v-model="search_criteria.courier_selected" :options="courier_options" />
            </b-col>
            <b-col cols="3" class="pl-0 pr-1">
              <b-form-input id="input-small" size="sm" type="text" placeholder="Packing Sector"
                v-model="search_criteria.packing_sector"></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.tier_selected" :options="tracking_tier_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1" v-if="$store.state.user_obj.client_id == 3">
              <b-form-select size="sm" v-model="search_criteria.client_selected" :options="client_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.route_selected" :options="route_options" />
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col cols="2" class="pr-1">
              <b-form-select size="sm" v-model="sort_by_col" :options="sort_by_col_options" />
            </b-col>
            <b-col cols="2" class="pl-0 pr-0">
              <b-form-select size="sm" v-model="sort_by_order" :options="sort_by_order_options" />
            </b-col>
            <b-col>
              <b-button v-if="
                checkPermission(
                  $store.state.user_obj,
                  'Delivery Management',
                  'Delivery Status',
                  'Search',
                  true
                )
              " class="btn-action" size="sm" variant="info" @click="onSearch">
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button>

              <b-button v-if="
                checkPermission(
                  $store.state.user_obj,
                  'Delivery Management',
                  'Delivery Status',
                  'Export CSV',
                  true
                )
              " class="btn-action" size="sm" variant="info" @click="exportCSV">
                Export
              </b-button>

              <b-button v-if="
                checkPermission(
                  $store.state.user_obj,
                  'Delivery Management',
                  'Delivery Status',
                  'Export Product Serial',
                  ($store.state.user_obj &&
                    $store.state.user_obj.permissions.export_product_serial)
                )
              " class="btn-action" size="sm" variant="info" @click="exportProductSerialReportv2">
                Export Product Serial Report
              </b-button>
            </b-col>
          </b-row>
        </div>

        <!-- <div
          class="search_bar mb-3"
          v-if="
            $store.state.user_obj.id != '88' &&
              ($store.state.user_obj.account_type == 'admin' ||
                $store.state.user_obj.account_type == 'cs')
          "
        >
          <b-row>
            <b-col cols="2" class="pr-1">
              <b-form-select
                size="sm"
                v-model="export_criteria.courier_selected"
                :options="courier_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="export_criteria.status_selected"
                :options="status_options"
              />
            </b-col>
            <b-col cols="2" class="pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="export_date.start_at"
              ></b-form-input>
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="date"
                v-model="export_date.end_at"
              ></b-form-input>
            </b-col>
            <b-col class="text-left p-0">
              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="exportCSV"
                >Export CSV</b-button
              >

              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="downloadExcel"
                >Download Excel</b-button
              >
            </b-col>
          </b-row>
        </div> -->

        <!-- <div class="search_bar mb-3">
          <b-row>
            <b-col cols="2" class="pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="text"
                placeholder="Tracking#"
                v-model="manual_return_tracking_number"
                v-on:keyup.enter="onManualReturnToWarehouse"
              ></b-form-input>
            </b-col>
            <b-col class="text-left p-0">
              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="onManualReturnToWarehouse"
                >Returned to Warehouse</b-button
              >
            </b-col>
          </b-row>
        </div> -->
      </b-card>

      <div class="search_bar mb-1">
        <b-row>
          <b-col class="pr-1">
            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Delivery Status',
                'Download Waybill',
                true
              )
            " class="btn-action" size="sm" variant="info" @click="bulkMoveWaybill">Move Waybill</b-button>
            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Delivery Status',
                'Download Waybill',
                true
              )
            " class="btn-action" size="sm" variant="info" @click="bulkDownloadWaybill">Download Waybill</b-button>
            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Delivery Status',
                'Download Waybill',
                true
              ) &&
              (this.$store.state.user_obj.client_id == '8' ||
                this.$store.state.user_obj.client_id == '22')
            " class="btn-action" size="sm" variant="info" @click="bulkDownloadInvoice">Download Invoice</b-button>
            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Delivery Status',
                'Download Packing List',
                true
              )
            " class="btn-action" size="sm" variant="info" @click="bulkDownloadPacking">Download Packing
              List</b-button>

            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Delivery Status',
                'Bulk Download Waybill & Packing List',
                true
              )
            " class="btn-action" size="sm" variant="info" @click="bulkDownloadFulfill">Bulk Download Waybill &
              Packing List</b-button>

            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Delivery Status',
                'Add To Packing Queue',
                true
              )
            " class="btn-action" size="sm" variant="info" @click="openAddToPackingQueueModal">Add To Packing
              Queue</b-button>

            <b-button v-if="
              checkPermission(
                $store.state.user_obj,
                'Delivery Management',
                'Delivery Status',
                'Add To Packing Queue',
                true
              )
            " class="btn-action" size="sm" variant="info" @click="showPackingSectorModal">Assign Packing Sector
              Code</b-button>
          </b-col>
        </b-row>
      </div>

      <!-- <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination> -->
      <strong># of Records: {{ total_rows }}</strong>

      <b-row class="mt-2">
        <b-col cols="1" class="pr-0">
          <b-form-select size="sm" v-model="sel_table_limit" :options="[50, 100, 200, 500, 1000]"
            @change="getTrackings()" />
        </b-col>
        <b-col class="pr-1">
          <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
            @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
        </b-col>
      </b-row>

      <b-table class="mt-0" responsive small outlined striped hover :items="items" :fields="fields"
        :tbody-tr-class="rowClass">
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox size="sm" plain id="chkbox_all" value="all" v-model="check_all_rows"></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"></b-form-checkbox>
        </template>
        <template v-slot:cell(status)="data">
          {{ data.item.status }}
          <!-- <span v-if="data.item.status_reason"
            >- {{ data.item.status_reason }}</span
          > -->
          <span v-if="data.item.other_reason">
            <br />
            [{{ data.item.other_reason }}]
          </span>
        </template>

        <template v-slot:cell(attention)="data">
          <span v-if="!data.item.attention_driver">{{
            data.item.attention
          }}</span>
          <span v-if="data.item.attention_driver">{{
            data.item.attention_driver
          }}</span>
        </template>

        <template v-slot:cell(phone)="data">
          <span v-if="!data.item.phone_driver">{{ data.item.phone }}</span>
          <span v-if="data.item.phone_driver">{{
            data.item.phone_driver
          }}</span>
        </template>

        <template v-slot:cell(tracking_number)="data">
          <router-link :to="{
            name: 'tracking_detail',
            params: { id: data.item.id },
          }">
            {{ data.item.tracking_number }}
          </router-link>
        </template>

        <template v-slot:cell(order_number)="data">
          <div @click="onClickOrderNumber(data.item)" style="cursor: pointer;">
            {{ data.item.order_number }}
          </div>
        </template>

        <template v-slot:cell(carried_by)="data">
          <span v-if="data.item.carried_by && data.item.carried_by != ''">
            <span v-if="$store.state.user_obj.account_type != 'client_user'">
              {{ data.item.carried_by || "-" }}
            </span>
            <span v-if="$store.state.user_obj.account_type == 'client_user'">
              -
            </span>
          </span>
          <span v-if="!(data.item.carried_by && data.item.carried_by != '')">-</span>
        </template>

        <template v-slot:cell(pod_image)="data">
          <!-- <a
            v-if="data.item.pod_image"
            :href="data.item.pod_image"
            target="_blank"
          >{{data.item.pod_type}}</a>-->
          <div style="text-align: center" v-if="
            checkPermission(
              $store.state.user_obj,
              'Delivery Management',
              'Delivery Status',
              'POD Records',
              true
            )
          ">
            <b-button class="btn-action" size="sm" variant="info" v-if="!(($store.state.user_obj.account_type == 'client_user')
              && data.item.pod_type == 'photo'
            ) && data.item.pod_image" @click="showPod(data.item)">{{ data.item.pod_type }}</b-button>
            <span v-if="(($store.state.user_obj.account_type == 'client_user')
              && data.item.pod_type == 'photo'
            ) || !data.item.pod_image">-</span>
          </div>
        </template>

        <template v-slot:cell(ready_for_packing)="data">
          <div>
            <span v-if="data.item.ready_for_packing == '0'" class="dot_red"></span>
            <span v-if="data.item.ready_for_packing == '1'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(schedule_date)="data">
          <span v-if="!data.item.reschedule_delivery_date">{{
            displayDate(data.item.schedule_date)
          }}</span>
          <span v-if="data.item.reschedule_delivery_date">{{ data.item.reschedule_type }}
            {{ displayDate(data.item.reschedule_delivery_date) }}</span>
        </template>

        <template v-slot:cell(scheduled_delivery_date)="data">
          {{ displayDate(data.item.scheduled_delivery_date) }}
        </template>

        <template v-slot:cell(packing_print_at)="data">
          {{ data.item.packing_print_at || "-" }}
        </template>

        <template v-slot:cell(waybill_print_at)="data">
          {{ data.item.waybill_print_at || "-" }}
        </template>

        <template v-slot:cell(pdf_print_at)="data">
          {{ data.item.pdf_print_at || "-" }}
        </template>

        <!-- <template v-slot:cell(packing_queues)="data">
          <div v-if="data.item.packing_queues.length > 0">
            <ul v-for="(queue, i) in data.item.packing_queues" :key="i">
              <li>{{ queue.queue_name }}</li>
            </ul>
          </div>
          <div v-if="data.item.packing_queues.length == 0">-</div>
        </template> -->

        <template v-slot:cell(action)="data">
          <b-button v-if="
            checkPermission(
              $store.state.user_obj,
              'Delivery Management',
              'Delivery Status',
              'Order Detail',
              true
            )
          " class="btn-action" size="sm" variant="info"
            :to="{ name: 'tracking_detail', params: { id: data.item.id } }">Detail</b-button>

          <b-button v-if="
            checkPermission(
              $store.state.user_obj,
              'Delivery Management',
              'Delivery Status',
              'Print Waybill',
              true
            )
          " class="btn-action" size="sm" variant="info" @click.stop="showModal_printWaybill(data.item)">Print
            Waybill</b-button>

          <b-button v-if="
            false &&
            checkPermission(
              $store.state.user_obj,
              'Delivery Management',
              'Delivery Status',
              'Toggle Ready for Packing',
              true
            )
          " class="btn-action" size="sm" variant="info" @click.stop="toogleRFP(data.item)">Toggle Ready For
            Packing</b-button>

          <span v-if="
            $store.state.user_obj.account_type == 'admin' ||
            $store.state.user_obj.account_type == 'cs'
          ">
            <b-button class="btn-action" size="sm" variant="info" @click.stop="returnTracking(data.item)">
              <font-awesome-icon class="mr-1" icon="undo" />Returned
            </b-button>

            <b-button class="btn-action" size="sm" variant="info"
              @click.stop="showModal_reschedule_tracking(data.item)">
              <font-awesome-icon class="mr-1" icon="calendar-alt" />Reschedule
            </b-button>

            <b-button v-if="data.item.status != 'Cancelled'" class="btn-action" size="sm" variant="danger"
              @click.stop="showModal_cancelTracking(data.item)">Cancel</b-button>

            <b-button v-if="
              data.item.status == 'Cancelled' || data.item.status == 'Hold'
            " class="btn-action" size="sm" variant="danger" @click.stop="pendingTracking(data.item)">Pending</b-button>

            <b-button v-if="data.item.status != 'Hold'" class="btn-action" size="sm" variant="danger"
              @click.stop="showModal_holdTracking(data.item)">Hold</b-button>
          </span>
        </template>
      </b-table>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>

      <b-modal ref="modal_cancelTracking" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Tracking#: {{ updating_item.tracking_number }}</b-col>
          </b-row>

          <b-row>
            <b-col>
              <label>Cancel Reason:</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-input id="input-small" size="sm" type="text" placeholder="Remark"
                v-model="updating_item.remark"></b-form-input>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_cancelTracking">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="cancelTracking()">Confirm</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_reschedule_tracking" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Tracking#: {{ updating_item.tracking_number }}</b-col>
          </b-row>

          <b-row>
            <b-col>
              <label>Reschedule:</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="auto" class="pr-0">
              <b-form-radio-group id="btnradios2" buttons button-variant="outline-info"
                v-model="reschedule_type_selected" :options="reschedule_type_options" name="radioBtnOutline" />
            </b-col>
            <b-col class="pl-1">
              <b-form-input id="reschedule_delivery_date" type="date" v-model="reschedule_date"></b-form-input>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_reschedule_tracking">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="rescheduleTracking()">Confirm</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_holdTracking" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Tracking#: {{ updating_item.tracking_number }}</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_holdTracking">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="holdTracking()">Confirm</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_confirmUpdateTrackingNum" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>
              <div>Do you confirm to update tracking # in these orders?</div>
              <div v-for="(item, index) in tracking_updated_orders" :key="index">
                {{ item.order_number }}: {{ item.update_from }} to
                {{ item.update_to }}
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_confirmUpdateTracking">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="onImportTrackingNum(1)">Confirm</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_printWaybill" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-1">
            <b-col>Tracking#: {{ print_item.tracking_number }}</b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col>
              <b-form-select size="sm" v-model="print_item.no_of_waybill" :options="no_of_waybill_options" />
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_printWaybill">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="printWaybill()">Download</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_add_to_packing_queue_ref" title="Add to packing queue" @show="resetAddToPackingQueueRef"
        @hidden="resetAddToPackingQueueRef" @ok="handleAddToPackingQueueOk">
        <form ref="form">
          <b-row class="mb-2">
            <b-col class="col-6">
              <strong>Packing List Name</strong>
            </b-col>
            <b-col>
              <b-form-group :state="packingQueueNameState" invalid-feedback='Packing Queue Name cannot contain "/"'>
                <b-form-input size="sm" type="text" v-model.trim="packing_queue_obj.queue_name"
                  :state="packingQueueNameState" @input="validatePackingQueueName"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-6">
              <strong>Remark</strong>
            </b-col>
            <b-col>
              <b-form-group>
                <b-form-textarea size="sm" type="text" placeholder v-model="packing_queue_obj.remark"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="packing_queue_obj.tracking_ids">
            <b-col class="col-12">
              Selected {{ packing_queue_obj.tracking_ids.length }} items.
            </b-col>

            <b-col class="col-12" style="color: red" v-if="packing_queue_obj.display_exist_message">
              Selected item is added to an existing packing queue.
            </b-col>
          </b-row>
        </form>
      </b-modal>
      <!-- Assign Packing Sector Code Modal -->
      <b-modal ref="modal_packing_sector" title="Assign Packing Sector Code" @ok="validateAndSubmit"
        @hidden="resetPackingSectorForm">
        <b-form>
          <b-form-select id="packing-sector-type" v-model="packingSector.packing_sector_channel"
            :options="packingSectorChannelOptions" />

          <b-form-group label="Scheduled Delivery Date:" label-for="scheduled-date">
            <b-form-input id="scheduled-date" type="date" v-model="packingSector.scheduled_date" :min="today"
              required></b-form-input>
            <b-form-invalid-feedback v-if="!isValidDate">
              Scheduled delivery date must be today or later.
            </b-form-invalid-feedback>
          </b-form-group>

          <!-- Postfix Input -->
          <b-form-group label="Postfix:" label-for="postfix">
            <b-form-input id="postfix" type="text" v-model="packingSector.postfix" placeholder="Enter Postfix"
              @input="updatePackingSectorPreview" required></b-form-input>
            <b-form-invalid-feedback v-if="!packingSector.postfix">
              Postfix is required.
            </b-form-invalid-feedback>
          </b-form-group>

          <!-- Packing Sector Code Preview -->
          <b-alert variant="info" show v-if="packingSectorPreview">
            <strong>Preview:</strong> {{ packingSectorPreview }}
          </b-alert>
        </b-form>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";

const fields = [
  {
    key: "chk_box",
    label: "",
  },
  {
    key: "client_name",
    label: "Client",
  },
  {
    key: "order_number",
    label: "Order#",
  },
  {
    key: "courier_short_name",
    label: "Courier",
  },
  {
    key: "tracking_number",
    label: "Tracking#",
  },
  // {
  //   key: "dn_number",
  //   label: "Delivery Note#"
  // },
  // {
  //   key: "cn_number",
  //   label: "Collection Note#"
  // },
  // {
  //   key: "attention",
  //   label: "Attention"
  // },
  // {
  //   key: "phone",
  //   label: "Phone"
  // },
  // {
  //   key: "ready_for_packing",
  //   label: "Ready For Packing",
  //   class: " center_align container-status",
  // },
  {
    key: "status",
    label: "Status",
  },
  {
    key: "schedule_date",
    label: "Process Date",
  },
  {
    key: "scheduled_delivery_date",
    label: "Scheduled Date",
  },
  {
    key: "pod_image",
    label: "POD Record",
  },
  {
    key: "carried_by",
    label: "Carried by",
  },
  // {
  //   key: "packing_queue",
  //   label: "Packing Queue",
  // },
  {
    key: "packing_queues",
    label: "Packing Queues",
  },
  {
    key: "updated_at",
    label: "Last Updated",
  },
  {
    key: "packing_print_at",
    label: "Packing Printed",
  },
  {
    key: "waybill_print_at",
    label: "Waybill Printed",
  },
  {
    key: "pdf_print_at",
    label: "PDF Printed",
  },
  {
    key: "action",
    label: "Action",
  },
];

const masked_fields = [
  {
    key: "chk_box",
    label: "",
  },
  {
    key: "client_name",
    label: "Client",
  },
  {
    key: "order_number",
    label: "Order#",
  },
  {
    key: "courier_short_name",
    label: "Courier",
  },
  {
    key: "tracking_number",
    label: "Tracking#",
  },
  {
    key: "status",
    label: "Status",
  },
  {
    key: "schedule_date",
    label: "Process Date",
  },
  {
    key: "scheduled_delivery_date",
    label: "Scheduled Date",
  },
  {
    key: "updated_at",
    label: "Last Updated",
  },
  {
    key: "action",
    label: "Action",
  },
];

import global_function from "../mixins/global_function";

export default {
  name: "Trackings",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService, global_function],
  components: {
    barcode: VueBarcode,
  },
  data() {
    return {
      packingQueueNameError: "",
      packingSector: {
        scheduled_date: moment().format("YYYY-MM-DD"), // Default to today
        postfix: "",
        packing_sector_channel: "", // Default selection
      },
      packingSectorChannelOptions: [
        {
          value: null,
          text: "All Channel",
        },
      ],
      today: moment().format("YYYY-MM-DD"),
      isValidDate: true,
      sel_table_limit: 100,
      courier_options: [],
      route_options: [],
      export_date: {
        start_at: moment().subtract(7, "d").format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),
      },
      upload_file: [],
      upload_file_tracking: [],
      upload_file_tracking_status: [],
      upload_file_packing_sector_priority: [],
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_tracking_number: "",
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null,
        route_selected: null,
      },
      search_criteria: {
        keyword: "",
        packing_sector: "",
        status_selected: null,
        case_created_by: null,
        has_delivery_case: false,
        has_cs_case: false,
        ready_for_packing: 1,

        // Upload Date (required)
        start_at: moment().subtract(3, "months").format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),

        // Scheduled Date
        scheduled_delivery_date: null,
        scheduled_delivery_date_start_at: moment()
          .subtract(3, "months")
          .format("YYYY-MM-DD"),
        scheduled_delivery_date_end_at: moment()
          .add(1, "months")
          .format("YYYY-MM-DD"),

        client_selected: null,
        courier_selected: null,
        waybill_status_selected: null,
        pdf_status_selected: null,
        tier_selected: null,
        route_selected: null,
      },
      scheduled_delivery_date_options: [
        {
          value: null,
          text: "All Scheduled Date",
        },
        {
          value: "scheduled_date_yes",
          text: "Scheduled Date",
        },
        {
          value: "scheduled_date_no",
          text: "NO Scheduled Date",
        },
      ],
      status_options: [
        {
          value: null,
          text: "All Status",
        },
        {
          value: "Pending",
          text: "Pending",
        },
        {
          value: "In_Transit",
          text: "In_Transit",
        },
        {
          value: "Successful",
          text: "Successful",
        },
        {
          value: "Cancelled",
          text: "Cancelled",
        },
        {
          value: "Shipped_Ext",
          text: "Shipped_Ext",
        },
        {
          value: "Returned_to_Warehouse",
          text: "Returned_to_Warehouse",
        },
        {
          value: "Rescheduled",
          text: "Rescheduled",
        },
        {
          value: "Unsuccessful_Delay",
          text: "Unsuccessful_Delay",
        },
        {
          value: "Unsuccessful_Other",
          text: "Unsuccessful_Other",
        },
        {
          value: "Unsuccessful_Reject",
          text: "Unsuccessful_Reject",
        },
        {
          value: "Hold",
          text: "Hold",
        },
        {
          value: "Unsuccessful_Unreach",
          text: "Unsuccessful_Unreach",
        },
        {
          value: "Ready_for_Fulfilment",
          text: "Ready_for_Fulfilment",
        },
        {
          value: "Ready_for_Shipment",
          text: "Ready_for_Shipment",
        },
        {
          value: "Ready_for_Redemption",
          text: "Ready_for_Redemption",
        },
        {
          value: "Redemption_Reserved",
          text: "Redemption_Reserved",
        },
        {
          value: "Redemption_Checked-In ",
          text: "Redemption_Checked-In ",
        },
        {
          value: "Redemption_Expired",
          text: "Redemption_Expired",
        },
        {
          value: "Redemption_Checked-Out",
          text: "Redemption_Checked-Out",
        },
        {
          value: "Redemption_Collected",
          text: "Redemption_Collected",
        },
        {
          value: "Redemption_Autovoided",
          text: "Redemption_Autovoided",
        },
        {
          value: "Redemption_Returned",
          text: "Redemption_Returned",
        },
        {
          value: "Redemption_Abnormal",
          text: "Redemption_Abnormal",
        },
        {
          value: "Redemption_CancelledCustomer",
          text: "Redemption_CancelledCustomer",
        },
        {
          value: "Redemption_Cancelled",
          text: "Redemption_Cancelled",
        },
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before",
        },
        {
          value: "on",
          text: "on",
        },
        {
          value: "after",
          text: "after",
        },
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      search_user_options: [],
      check_all_rows: false,

      print_item: {},
      no_of_waybill_options: [
        {
          value: 1,
          text: "1",
        },
        {
          value: 2,
          text: "2",
        },
        {
          value: 3,
          text: "3",
        },
        {
          value: 4,
          text: "4",
        },
        {
          value: 5,
          text: "5",
        },
      ],

      client_name: false,
      sort_by_col: "updated_at",
      sort_by_order: "DESC",
      sort_by_col_options: [
        {
          value: "updated_at",
          text: "Sort by: Last Updated",
        },
        {
          value: "schedule_date",
          text: "Sort by: Process Date",
        },
        {
          value: "packing_print_at",
          text: "Sort by: Packing Printed",
        },
        {
          value: "waybill_print_at",
          text: "Sort by: Waybill Printed",
        },
        {
          value: "order_number",
          text: "Sort by: Order#",
        },
        {
          value: "tracking_number",
          text: "Sort by: Tracking#",
        },
        {
          value: "packing_seq",
          text: "Sort by: Packing Sequence",
        },
      ],
      sort_by_order_options: [
        {
          value: "DESC",
          text: "Descending",
        },
        {
          value: "ASC",
          text: "Ascending",
        },
      ],
      client_options: [
        {
          value: null,
          text: "All Clients",
        },
      ],
      waybill_status_options: [
        {
          value: null,
          text: "All Waybill Status",
        },
        {
          value: "waybill_printed",
          text: "Waybill Printed",
        },
        {
          value: "waybill_not_printed",
          text: "Waybill NOT Printed",
        },
      ],

      PDF_status_options: [
        {
          value: null,
          text: "All PDF Status",
        },
        {
          value: "pdf_printed",
          text: "PDF Printed",
        },
        {
          value: "pdf_not_printed",
          text: "PDF NOT Printed",
        },
      ],

      tracking_tier_options: [
        {
          value: null,
          text: "All Tier",
        },
        {
          value: "1",
          text: "Tier - L1",
        },
        {
          value: "2",
          text: "Tier - L2",
        },
        {
          value: "3",
          text: "Tier - L3",
        },
      ],

      packing_queue_obj: {
        queue_name: "",
        remark: "",
        tracking_ids: [],
      },

      addToPackingQueueDisabled: false,
      tracking_updated_orders: [],
      packingSectorPreview: '',
    };
  },
  async created() {
    if (this.$store.state.user_obj.account_type == "client_user_masked") {
      this.fields = masked_fields;
      this.$root.$emit("bv::refresh::table", "btable_main");
    }

    await this.getTrackings();
    await this.getCouriers();
    await this.getRoutes();

    let channels_response = await this.getChannels(this.$store.state.user_obj);
    for (let i in channels_response.channels) {
      this.packingSectorChannelOptions.push({
        value: channels_response.channels[i].name,
        text: channels_response.channels[i].name,
      });
    }

    let clients_response = await this.getClients_old(
      this.$store.state.user_obj
    );
    for (let i in clients_response.clients) {
      this.client_options.push({
        value: clients_response.clients[i].name,
        text:
          clients_response.clients[i].full_name +
          " (" +
          clients_response.clients[i].name +
          ")",
      });
    }

    if (
      this.$store.state.user_obj.client_id == 77 &&
      this.$store.state.user_obj.account_type == "client_user"
    ) {
      this.search_criteria.waybill_status_selected = "waybill_not_printed";
    }

    this.initialized = true;
  },
  mounted() {
    // $('#summernote').summernote();
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false,
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    },
  },
  computed: {
    packingQueueNameState() {
      if (!this.packing_queue_obj.queue_name) return null;
      return !this.packingQueueNameError;
    },
  },
  methods: {
    holdTracking() {
      this.updateTracking(
        this.updating_item,
        "Hold",
        null,
        null,
        this.updating_item.remark
      );
    },

    showModal_confirmUpdateTracking() {
      this.$refs.modal_confirmUpdateTrackingNum.show();
    },

    hideModal_confirmUpdateTracking() {
      this.$refs.modal_confirmUpdateTrackingNum.hide();
    },

    showModal_holdTracking(item) {
      this.updating_item = item;
      this.$refs.modal_holdTracking.show();
    },

    hideModal_holdTracking() {
      this.$refs.modal_holdTracking.hide();
    },

    showModal_printWaybill(item) {
      this.print_item = item;
      this.print_item.no_of_waybill = 1;
      this.printWaybill();
    },

    hideModal_printWaybill() {
      this.$refs.modal_printWaybill.hide();
    },

    displayDate(d) {
      if (d == "0000-00-00") {
        return "-";
      } else if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "-";
      }
    },

    async getTrackings() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_get.php",
        data: {
          offset: this.table_offset,
          limit: this.sel_table_limit,
          sort_by_col: this.sort_by_col,
          sort_by_order: this.sort_by_order,
          search_criteria: this.search_criteria,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.items = response.data.trackings;
      this.total_rows = parseInt(response.data.total_rows);
      if (response.data.trackings && response.data.trackings.length > 0) {
        this.client_name = response.data.trackings[0].client_name;
      }
      this.loader.hide();
    },

    async getCouriers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "couriers_get.php",
        data: {},
      });

      this.courier_options = [
        {
          value: null,
          text: "All Couriers",
        },
      ];

      for (let i in response.data.couriers) {
        let courier_obj = {
          value: response.data.couriers[i].short_name,
          text: response.data.couriers[i].long_name,
        };

        this.courier_options.push(courier_obj);
      }
    },
    async getRoutes() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "route_option_get.php",
        data: {},
      });

      this.route_options = [
        {
          value: null,
          text: "All Routes",
        },
      ];

      for (let i in response.data.tracking_routes) {
        let route_obj = {
          value: response.data.tracking_routes[i].route_name,
          text: response.data.tracking_routes[i].route_name,
        };

        this.route_options.push(route_obj);
      }
    },
    async onImportTrackingNum(confirm = 0) {
      // console.log(this.upload_file);
      // return;
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.hideModal_confirmUpdateTracking();

      let formData = new FormData();
      formData.append("excel_file", this.upload_file_tracking);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);
      formData.append("confirm", confirm);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_courier_import.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });
      console.log(response);
      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        // window.location.reload();
        if (response.data.status == "success") {
          if (response.data.require_confirmation == 1) {
            this.tracking_updated_orders =
              response.data.tracking_updated_order_numbers || [];
            this.showModal_confirmUpdateTracking();
          } else {
            this.$eventHub.$emit("show_modal_message", {
              message_content: "Upload Success",
            });

            this.getTrackings();
          }
        } else {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.error_msg,
          });
        }
      }
    },

    async onImportStatus() {
      // return;
      // console.log(this.upload_file);
      // return;
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file_tracking_status);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_import_status.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });
      console.log(response);
      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        // window.location.reload();
      }
    },
    async onUploadFile() {
      // console.log(this.upload_file);
      // return;
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_import.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });
      console.log(response);
      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        // window.location.reload();

        await this.getTrackings();
      }
    },
    async onImportPackingSectorPriority() {

      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file_packing_sector_priority);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_import_packing_sector_priority.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });
      console.log(response);
      if (response) {
        this.loader_full.hide();
      }
    },

    onSearch() {
      if (!this.search_criteria.start_at || !this.search_criteria.end_at) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Upload Date is required.",
          variant: "danger",
        });
        return;
      }

      if (
        this.search_criteria.scheduled_delivery_date == "scheduled_date_yes" &&
        (
          !this.search_criteria.scheduled_delivery_date_start_at ||
          !this.search_criteria.scheduled_delivery_date_end_at
        )
      ) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Scheduled Date range is required.",
          variant: "danger",
        });
        return;
      }

      this.table_offset = 0;
      this.currentPage = 1;
      this.getTrackings();
    },

    downloadExcel() {
      let export_url =
        "https://tracking.gols.com.hk/driver/export/gols_tracking_bulk.xlsx";
      window.open(export_url, "_blank");
    },

    exportCSV() {
      let export_url = process.env.NODEJS_API_URL + "/export_tracking?";
      export_url += "start_at=" + this.search_criteria.start_at;
      export_url += "&end_at=" + this.search_criteria.end_at;
      export_url += "&courier_name=" + this.export_criteria.courier_selected;
      export_url += "&utype=" + this.$store.state.user_obj.account_type;

      if (this.$store.state.user_obj.client_id != 3) {
        if (this.$store.state.user_obj.account_type === "client_user_masked") {
          export_url += "&client_name=" + this.client_name + "_m";
        } else {
          export_url += "&client_name=" + this.client_name;
        }
      }

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: export_url,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const disposition = response.headers["content-disposition"];
          if (
            response.data.type === "application/json" ||
            !disposition ||
            disposition.indexOf("attachment") === -1
          ) {
            const reader = new FileReader();
            reader.onload = () => {
              const errMsg = reader.result || "Unknown error occurred";
              this.$eventHub.$emit("show_modal_message", {
                message_content: errMsg,
                variant: "danger"
              });
              this.loader.hide();
            };
            reader.readAsText(response.data);
            return;
          }

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "tracking.xlsx");
          document.body.appendChild(link);
          link.click();

          this.loader.hide();
        })
        .catch((error) => {
          console.error("Export failed:", error);
          const reader = new FileReader();
          reader.onload = () => {
            const errMsg = reader.result || "Unexpected error occurred";
            this.$eventHub.$emit("show_modal_message", {
              message_content: errMsg,
              variant: "danger"
            });
            this.loader.hide();
          };

          if (error.response && error.response.data) {
            reader.readAsText(error.response.data);
          } else {
            this.$toast.error("Network error or no response from server.");
            this.loader.hide();
          }
        });
    },

    async _exportCSV() {
      if (!this.search_criteria.start_at || !this.search_criteria.end_at) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Upload Date is required.",
          variant: "danger",
        });
        return;
      }

      if (
        this.search_criteria.scheduled_delivery_date == "scheduled_date_yes" &&
        (
          !this.search_criteria.scheduled_delivery_date_start_at ||
          !this.search_criteria.scheduled_delivery_date_end_at
        )
      ) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Scheduled Date range is required.",
          variant: "danger",
        });
        return;
      }

      let export_client_name = "";
      if (this.$store.state.user_obj.client_id != 3) {
        if (this.$store.state.user_obj.account_type === "client_user_masked") {
          export_client_name = this.client_name + "_m";
        } else {
          export_client_name = this.client_name;
        }
      } else {
        export_client_name = this.search_criteria.client_selected;
      }

      // if (!export_client_name) {
      //   this.$eventHub.$emit("show_modal_message", {
      //     message_content: "Please select a client before export.",
      //     variant: "danger",
      //   });
      //   return;
      // }

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      try {
        const response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "tracking_export_csv.php",
          data: {
            account_type: this.$store.state.user_obj.account_type,
            client_id: this.$store.state.user_obj.client_id,
            user_id: this.$store.state.user_obj.user_id,
            client_name: export_client_name,
            sort_by_col: this.sort_by_col,
            sort_by_order: this.sort_by_order,
            search_criteria: this.search_criteria
          }
        });

        if (response.data && response.data.status === "success") {
          const link = document.createElement("a");
          link.href = `${this.API_HOST}/${response.data.download_url}`;
          link.setAttribute("download", response.data.file_name || "tracking_export.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          this.$eventHub.$emit("show_modal_message", {
            message_content: (response.data && response.data.message) || "Export failed.",
            variant: "danger"
          });
        }
      } catch (error) {
        let errMsg = "Unexpected error occurred";

        if (error.response && error.response.data) {
          if (typeof error.response.data === "string") {
            errMsg = error.response.data;
          } else if (error.response.data.message) {
            errMsg = error.response.data.message;
          }
        }

        this.$eventHub.$emit("show_modal_message", {
          message_content: errMsg,
          variant: "danger"
        });
      } finally {
        this.loader.hide();
      }
    },


    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.sel_table_limit;
      this.getTrackings();
    },

    showModal_reschedule_tracking(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_tracking.show();
    },

    hideModal_reschedule_tracking() {
      this.$refs.modal_reschedule_tracking.hide();
    },

    returnTracking(item) {
      this.updateTracking(
        item,
        "returned_to_warehouse",
        null,
        null,
        item.remark
      );
    },

    cancelTracking() {
      this.updateTracking(
        this.updating_item,
        "cancel",
        null,
        null,
        this.updating_item.remark
      );
    },

    showModal_cancelTracking(item) {
      this.updating_item = item;
      this.$refs.modal_cancelTracking.show();
      // this.updateTracking(item.tracking_number, "Cancelled", null, null);
    },

    hideModal_cancelTracking() {
      this.$refs.modal_cancelTracking.hide();
    },

    rescheduleTracking() {
      this.updateTracking(
        this.updating_item,
        "Rescheduled",
        this.reschedule_type_selected,
        this.reschedule_date
      );
    },

    pendingTracking(item) {
      this.updateTracking(item, "Pending", null, null);
    },

    onManualReturnToWarehouse() {
      this.updateTracking(
        {
          id: this.manual_return_tracking_number,
          tracking_number: this.manual_return_tracking_number,
          by_tracking_number: true,
        },
        "Returned_to_Warehouse",
        null,
        null
      );
    },

    async updateTracking(
      tracking_obj,
      status,
      reschedule_delivery_type,
      reschedule_delivery_date,
      remark
    ) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_update.php",
        data: {
          id: tracking_obj.id,
          status: status,
          reschedule_type: reschedule_delivery_type,
          reschedule_delivery_date: reschedule_delivery_date,
          other_reason: remark,
          user_id: this.$store.state.user_obj.user_id,
          by_tracking_number: tracking_obj.by_tracking_number,
        },
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Tracking #${tracking_obj.tracking_number} Update Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
        this.getTrackings();
      } else {
        this.alert_error_message = `Tracking #${tracking_obj.id} not found.`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
          this.alert_error_message = "";
        }, 3000);
      }

      this.$refs.modal_reschedule_tracking.hide();
      this.$refs.modal_cancelTracking.hide();
    },

    async showPod(item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_pod_get.php",
        data: {
          tracking_id: item.id,
          tracking_number: item.tracking_number,
        },
      });

      item.order_ids = response.data.order_ids;
      item.pod_at = response.data.pod_at;

      this.$eventHub.$emit("show_image_view", {
        image_url: item.pod_image,
        order_ids: item.order_ids,
        pod_at: item.pod_at,
      });
    },

    async getYLUsers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "user_get.php",
        data: {
          account_type: "young_living",
        },
      });
      // this.yl_users = response.data.users;
      this.search_user_options = [
        {
          value: null,
          text: "All Users",
        },
      ];
      for (let i in response.data.users) {
        let tmp_user = response.data.users[i];
        this.search_user_options.push({
          value: tmp_user.name,
          text: tmp_user.name,
        });
      }
      this.loader.hide();
    },

    async bulkDownloadWaybill() {
      let no_of_waybill = 1;
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let courier_checked_items = {};
      let checked_items = [];
      let waybill_tracking_number = "";

      for (let i in this.items) {
        let item_tmp = this.items[i];
        let courier_short_name = item_tmp.courier_short_name.toLowerCase();
        let courier_checked_item =
          courier_checked_items[courier_short_name] || [];

        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != "" &&
          courier_checked_item.indexOf(item_tmp.tracking_number) == -1
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          console.log(item_tmp);
          console.log(courier_short_name);
          courier_checked_item.push(item_tmp.tracking_number);

          courier_checked_items[courier_short_name] = courier_checked_item;
        }
      }

      for (let [courier_short_name, courier_checked_item] of Object.entries(
        courier_checked_items
      )) {
        console.log(courier_short_name);
        console.log(courier_checked_item);

        if (!courier_checked_item || courier_checked_item.length == 0) {
          continue;
        }

        if (courier_short_name == "gols" || courier_short_name == "whole"
          || courier_short_name == "sf" || courier_short_name == "jd") {
          this.$http({
            url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
            method: "POST",
            data: {
              ids: courier_checked_item,
              print_packing: false,
              print_waybill: true,
              no_of_waybill: 1,
              user_id: this.$store.state.user_obj.user_id,
            },
            responseType: "blob", // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "waybill.pdf");
            document.body.appendChild(link);
            link.click();
            this.loader_full.hide();
          });
          for (let i in courier_checked_item) {
            let response = await this.$http({
              method: "POST",
              baseURL: `${this.API_HOST}`,
              url: "print_waybill_log.php",
              data: {
                tracking_number: courier_checked_item[i],
                client_id: this.$store.state.user_obj.client_id,
                user_id: this.$store.state.user_obj.user_id,
              },
            });
          }
        } else if (courier_short_name == "7-11") {
          this.$http({
            url: this.NODEJS_API_URL + "/redemption_waybill",
            method: "POST",
            data: {
              ids: courier_checked_item,
              print_packing: false,
              print_waybill: true,
              no_of_waybill: no_of_waybill,
              print_as_file: 1,
            },
            responseType: "blob", // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "waybill.pdf");
            document.body.appendChild(link);
            link.click();
            this.loader_full.hide();
          });
        } else if (courier_short_name != "sf-cn") {
          for (let i in courier_checked_item) {
            courier_short_name = courier_short_name.toUpperCase();
            let self = this;
            // let pdf_to_print_src =
            //   "https://tracking.gols.com.hk/waybill_file/" +
            //   courier_short_name +
            //   "/" +
            //   courier_checked_item[i] +
            //   ".pdf";

            let pdf_to_print_src =
              encodeURIComponent(
                courier_short_name +
                "/" +
                courier_checked_item[i]);

            this.pdf_to_print_trakcing_number = courier_checked_item[i];

            this.pdf_to_print = "https://sys.gols.com.hk/api/download_ftp_waybill.php?url=" + pdf_to_print_src;

            fetch(self.pdf_to_print).then(function (t) {
              return t.blob().then((b) => {
                var a = document.createElement("a");
                a.href = URL.createObjectURL(b);
                a.setAttribute("download", self.pdf_to_print_trakcing_number + ".pdf");
                a.click();
              });
            });

            let response = await this.$http({
              method: "POST",
              baseURL: `${this.API_HOST}`,
              url: "print_waybill_log.php",
              data: {
                tracking_number: courier_checked_item[i],
                client_id: this.$store.state.user_obj.client_id,
                user_id: this.$store.state.user_obj.user_id,
              },
            });
          }
        }
      }
      this.loader_full.hide();
    },

    async bulkMoveWaybill() {
      let no_of_waybill = 1;
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let courier_checked_items = {};
      let checked_items = [];
      let waybill_tracking_number = "";

      for (let i in this.items) {
        let item_tmp = this.items[i];
        let courier_short_name = item_tmp.courier_short_name.toLowerCase();
        let courier_checked_item =
          courier_checked_items[courier_short_name] || [];

        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != "" &&
          courier_checked_item.indexOf(item_tmp.tracking_number) == -1
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          console.log(item_tmp);
          console.log(courier_short_name);
          courier_checked_item.push(item_tmp.tracking_number);

          courier_checked_items[courier_short_name] = courier_checked_item;
        }
      }

      for (let [courier_short_name, courier_checked_item] of Object.entries(
        courier_checked_items
      )) {
        console.log(courier_short_name);
        console.log(courier_checked_item);

        if (!courier_checked_item || courier_checked_item.length == 0) {
          continue;
        }

        if (courier_short_name == "gols" || courier_short_name == "whole") {
          this.$http({
            url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
            method: "POST",
            data: {
              ids: courier_checked_item,
              print_packing: false,
              print_waybill: true,
              no_of_waybill: 1,
              user_id: this.$store.state.user_obj.user_id,
              print_as_file: 1,
              move_waybill: 1
            },
            responseType: "blob", // important
          }).then((response) => {
            this.loader_full.hide();
          });
        }
      }
      this.loader_full.hide();
    },

    async bulkToPackingQueue() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let checked_items = [];

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != ""
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          checked_items.push(item_tmp.tracking_number);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "addToPackingQueue.php",
        data: {
          tracking_numbers: checked_items,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Added to Packing List Queue.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
        this.getTrackings();
      }

      this.loader_full.hide();
    },

    async bulkDownloadPacking() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let checked_items = [];
      let waybill_tracking_number = "";

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != ""
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          checked_items.push(item_tmp.tracking_number);
        }
      }

      let print_order = false;
      if (
        this.$store.state.user_obj.client_id == "8" ||
        this.$store.state.user_obj.client_id == "22"
      ) {
        print_order = true;
      }

      this.$http({
        url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
        method: "POST",
        data: {
          ids: checked_items,
          print_packing: true,
          print_waybill: false,
          print_order: print_order,
          no_of_waybill: 1,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "packing.pdf");
        document.body.appendChild(link);
        link.click();
        this.loader_full.hide();
      });
    },

    async bulkDownloadInvoice() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let checked_items = [];
      let waybill_tracking_number = "";

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != ""
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          checked_items.push(item_tmp.tracking_number);
        }
      }

      let print_order = false;
      if (
        this.$store.state.user_obj.client_id == "8" ||
        this.$store.state.user_obj.client_id == "22"
      ) {
        print_order = true;
      }

      this.$http({
        url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
        method: "POST",
        data: {
          ids: checked_items,
          print_packing: false,
          print_waybill: false,
          print_order: print_order,
          no_of_waybill: 1,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "invoice.pdf");
        document.body.appendChild(link);
        link.click();
        this.loader_full.hide();
      });
    },

    async bulkDownloadFulfill() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let checked_items = [];
      let waybill_tracking_number = "";

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != ""
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          checked_items.push(item_tmp.tracking_number);
        }
      }

      this.$http({
        url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
        method: "POST",
        data: {
          ids: checked_items,
          print_packing: true,
          print_waybill: true,
          no_of_waybill: 1,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "fulfill.pdf");
        document.body.appendChild(link);
        link.click();
        this.loader_full.hide();
      });
    },

    async printWaybill() {
      let checked_items = [];
      checked_items.push(this.print_item.tracking_number);

      this.$http({
        url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
        method: "POST",
        data: {
          ids: checked_items,
          print_packing: false,
          print_waybill: true,
          no_of_waybill: this.print_item.no_of_waybill,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "waybill.pdf");
        document.body.appendChild(link);
        link.click();

        this.hideModal_printWaybill();
      });
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_checked) return "table-info";
    },

    async toogleRFP(tracking_obj) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_toggleRFP.php",
        data: {
          id: tracking_obj.id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      this.getTrackings();
    },

    async testDownloadWaybill() {
      let checked_items = [];
      let waybill_tracking_number = "";

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != ""
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          checked_items = [];
          checked_items.push(item_tmp.tracking_number);

          this.$http({
            url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
            method: "POST",
            data: {
              ids: checked_items,
              print_packing: false,
              print_waybill: true,
              no_of_waybill: 1,
            },
            responseType: "blob", // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "waybill.pdf");
            document.body.appendChild(link);
            link.click();
          });
        }
      }
    },

    openAddToPackingQueueModal: function () {
      let checked_items = [];
      let display_exist_message = false;

      for (let i in this.items) {
        let item_tmp = this.items[i];
        if (item_tmp.is_checked && item_tmp.id && item_tmp.id != "" && item_tmp.tracking_number != "") {
          checked_items.push(item_tmp.id);

          if (item_tmp.packing_queues && item_tmp.packing_queues.length > 0) {
            display_exist_message = true;
          }
        }
      }

      if (checked_items.length == 0) {
        return;
      }

      this.packing_queue_obj.tracking_ids = checked_items;
      this.packing_queue_obj.display_exist_message = display_exist_message;
      this.$refs.modal_add_to_packing_queue_ref.show();
    },

    resetAddToPackingQueueRef() {
      this.packing_queue_obj = {
        ...this.packing_queue_obj,
        queue_name: "",
        remark: "",
      };
      this.packingQueueNameError = "";
    },

    async handleAddToPackingQueueOk(event) {
      event.preventDefault();

      if (!this.validatePackingQueueName()) {
        this.alert_error_message = 'Packing Queue Name cannot contain "/"';
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
          this.alert_error_message = "";
        }, 3000);
        return;
      }
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "addToPackingQueue.php",
        data: {
          queue_name: this.packing_queue_obj.queue_name,
          remark: this.packing_queue_obj.remark,
          tracking_ids: this.packing_queue_obj.tracking_ids,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Added to Packing List Queue.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
        this.getTrackings();
      } else {
        this.alert_error_message = response.data.message;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
          this.alert_error_message = "";
        }, 3000);
      }

      this.$refs.modal_add_to_packing_queue_ref.hide();

      this.loader_full.hide();
    },

    async onClickOrderNumber(item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_get_id.php",
        data: {
          order_number: item.order_number,
          client_selected: item.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.order_id) {
        // window.open("/staging/portal/#/order_master_detail/"+response.data.order_id, '_blank', 'noreferrer');
        window.open("/portal/#/order_master_detail/" + response.data.order_id, '_blank', 'noreferrer');
      }
    },

    exportProductSerialReport() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "product_serial",
          search_criteria: {},
          client_id: this.$store.state.user_obj.client_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "product_serial_report.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    exportProductSerialReportv2() {
      let export_url =
        process.env.VUE_APP_API_HOST + "/kwhk_product_serial_report_export.php?";
      if (this.$store.state.user_obj.client_id != 86) {
        export_url =
          process.env.VUE_APP_API_HOST + "/product_serial_report_export.php?";
      }
      this.search_criteria.client_id = this.$store.state.user_obj.client_id;
      for (let i in this.search_criteria) {
        if (this.search_criteria[i] != null) {
          export_url += `&${i}=` + this.search_criteria[i];
        }
      }
      export_url = encodeURI(export_url);
      window.open(export_url, "_blank");
    },
    // Open the modal
    showPackingSectorModal() {
      this.$refs.modal_packing_sector.show();
    },

    // Reset modal data when hidden
    resetPackingSectorForm() {
      this.packingSector.scheduled_date = moment().format("YYYY-MM-DD");
      this.packingSector.postfix = "";
      this.isValidDate = true;
    },

    // Generate preview for Packing Sector Code
    updatePackingSectorPreview() {
      if (this.packingSector.scheduled_date && this.packingSector.postfix) {
        this.packingSectorPreview = `${this.packingSector.scheduled_date.replace(/-/g, '')}-${this.packingSector.postfix}`;
      } else {
        this.packingSectorPreview = '';
      }
    },

    // Validate inputs before submitting
    validateAndSubmit(event) {
      event.preventDefault();

      // Check if the date is valid (must be today or later)
      this.isValidDate = this.packingSector.scheduled_date >= this.today;

      // Ensure postfix is not empty
      if (!this.packingSector.postfix) {
        this.showAlert_error = true;
        this.alert_error_message = "Postfix is required.";
        return;
      }

      if (!this.isValidDate) {
        this.showAlert_error = true;
        this.alert_error_message = "Scheduled delivery date must be today or later.";
        return;
      }

      // Proceed to submit the form if validation passes
      this.submitPackingSector();
    },

    // Submit the form
    async submitPackingSector() {
      try {
        const response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "packing_sector_assign.php",
          data: {
            scheduled_date: this.packingSector.scheduled_date,
            postfix: this.packingSector.postfix,
            user_id: this.$store.state.user_obj.user_id, // Assuming user ID is needed
            client_id: this.$store.state.user_obj.client_id,
            packing_sector_channel: this.packingSector.packing_sector_channel, // NEW PARAMETER
          },
        });

        if (response.data.status === "success") {
          this.alert_success_message = "Packing Sector Assigned Successfully!";
          this.showAlert_success = true;

          // Set packing sector search criteria and trigger search
          this.search_criteria.packing_sector = `${this.packingSector.scheduled_date.replace(/-/g, '')}-${this.packingSector.postfix}`;
          this.onSearch();

        } else {
          this.alert_error_message = response.data.message || "Failed to assign packing sector.";
          this.showAlert_error = true;
        }
      } catch (error) {
        this.alert_error_message = "Error while assigning packing sector.";
        this.showAlert_error = true;
      }

      // Close modal
      this.$refs.modal_packing_sector.hide();
    },
    validatePackingQueueName() {
      const name = this.packing_queue_obj.queue_name || "";

      if (name.includes("/")) {
        this.packingQueueNameError = 'Packing Queue Name cannot contain "/"';
        return false;
      }

      this.packingQueueNameError = "";
      return true;
    },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Trackings.vue